var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGamingDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.315,
    height: 40.755,
    viewBox: "0 0 54.315 40.755",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gaming_Details",
    "data-name": "Gaming Details",
    transform: "translate(-1307.721 -3190.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1086",
    "data-name": "Ellipse 1086",
    cx: 1.125,
    cy: 1.125,
    r: 1.125,
    transform: "translate(1348.363 3213.369)",
    fill: "none",
    stroke: "#007513",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1087",
    "data-name": "Ellipse 1087",
    cx: 1.125,
    cy: 1.125,
    r: 1.125,
    transform: "translate(1348.363 3222.366)",
    fill: "none",
    stroke: "#007513",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1088",
    "data-name": "Ellipse 1088",
    cx: 1.125,
    cy: 1.125,
    r: 1.125,
    transform: "translate(1352.862 3217.867)",
    fill: "none",
    stroke: "#007513",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1089",
    "data-name": "Ellipse 1089",
    cx: 1.125,
    cy: 1.125,
    r: 1.125,
    transform: "translate(1343.865 3217.867)",
    fill: "none",
    stroke: "#007513",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_186",
    "data-name": "Path 186",
    d: "M904.988,706.5H876.05a11.427,11.427,0,0,0-11.294,8.806,11.253,11.253,0,0,0,21,7.578A5.174,5.174,0,0,1,890.327,720h.086a5.116,5.116,0,0,1,4.548,2.848,11.29,11.29,0,0,0,13.309,5.684,10.927,10.927,0,0,0,7.407-7.182A11.283,11.283,0,0,0,904.988,706.5Z",
    transform: "translate(444.5 2501.245)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    y2: 8.913,
    transform: "translate(1320.238 3214.51)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x2: 8.913,
    transform: "translate(1315.781 3218.967)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_187",
    "data-name": "Path 187",
    d: "M896.992,699.5h0a6.748,6.748,0,0,1-6.748,6.748h-9A6.748,6.748,0,0,0,874.5,713v1.125",
    transform: "translate(456.994 2492.5)",
    fill: "none",
    stroke: "#007513",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamingDetails);
export default __webpack_public_path__ + "static/media/Gaming Details.2ac9ef44c4c7eb7fd571cfb6d9538cc0.svg";
export { ForwardRef as ReactComponent };